import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ChevronRight } from "lucide-react";
import Header from "@/components/Header";
import BottomBar from "@/components/BottomBar";
import passwordChange01 from "@/assets/images/help/password-change-01.png";
import passwordChange02 from "@/assets/images/help/password-change-02.png";
import passwordChange03 from "@/assets/images/help/password-change-03.png";
import passwordChange04 from "@/assets/images/help/password-change-04.png";
import passwordChange05 from "@/assets/images/help/password-change-05.png";
import passwordChange06 from "@/assets/images/help/password-change-06.png";

export default function HelpPasswordChange() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background">
      <Header showBack={true} onBackClick={() => navigate("/help")} />

      <div className="max-w-md mx-auto px-4 pb-20">
        {/* Title */}
        <div className="mt-6 mb-9">
          <h1 className="text-[32px] font-bold leading-[1.6] opacity-80">
            Password Change Guide
          </h1>
        </div>

        {/* Content */}
        <div className="space-y-9">
          {/* Introduction */}
          <div className="space-y-4">
            <p className="text-base font-bold leading-[1.6] opacity-70 whitespace-pre-line">
              Change Your Fellas Card Account Password
              {"\n"}You can change your Fellas Card account password anytime.
              {"\n"}It is recommended to manage it properly for secure
              transactions.
            </p>
          </div>

          {/* Step 1 */}
          <div className="space-y-4">
            <h3 className="text-lg font-bold opacity-90">
              Step 1: Start Password Change
            </h3>
            <p className="text-base font-bold leading-[1.6] opacity-70">
              Go to your Profile screen and click the "Reset Password" button.
            </p>
            <div className="rounded-[10px] overflow-hidden shadow-[0px_0px_4px_0px_rgba(0,0,0,0.25)]">
              <img
                src={passwordChange01}
                alt="Password Change Step 1"
                className="w-full h-auto"
              />
            </div>
          </div>

          {/* Step 2 */}
          <div className="space-y-4">
            <h3 className="text-lg font-bold opacity-90">
              Step 2: Enter Email
            </h3>
            <p className="text-base font-bold leading-[1.6] opacity-70 whitespace-pre-line">
              Enter the email address of the account for which you want to
              change the password.
              {"\n"}Click the "Send" button to receive the password reset link.
            </p>
            <div className="rounded-[10px] overflow-hidden shadow-[0px_0px_4px_0px_rgba(0,0,0,0.25)]">
              <img
                src={passwordChange02}
                alt="Password Change Step 2"
                className="w-full h-auto"
              />
            </div>
          </div>

          {/* Step 3 - Send Link */}
          <div className="space-y-4">
            <h3 className="text-lg font-bold opacity-90">
              Step 3: Send Password Reset Link
            </h3>
            <p className="text-base font-bold leading-[1.6] opacity-70">
              A password reset link will be sent to the email address you
              entered.
            </p>
            <div className="rounded-[10px] overflow-hidden shadow-[0px_0px_4px_0px_rgba(0,0,0,0.25)]">
              <img
                src={passwordChange03}
                alt="Password Change Step 3"
                className="w-full h-auto"
              />
            </div>
          </div>

          {/* Step 4 - Check Email */}
          <div className="space-y-4">
            <h3 className="text-lg font-bold opacity-90">
              Step 4: Check Your Email
            </h3>
            <p className="text-base font-bold leading-[1.6] opacity-70 whitespace-pre-line">
              Check your inbox for an email from Fellas Card.
              {"\n"}Click the link in the email to go to the password reset
              page.
              {"\n"}(If you don't see the email, please check your spam
              folder.)
            </p>
            <div className="rounded-[10px] overflow-hidden shadow-[0px_0px_4px_0px_rgba(0,0,0,0.25)]">
              <img
                src={passwordChange04}
                alt="Password Change Step 4"
                className="w-full h-auto"
              />
            </div>
          </div>

          {/* Step 5 */}
          <div className="space-y-4">
            <h3 className="text-lg font-bold opacity-90">
              Step 5: Change Your Password
            </h3>
            <p className="text-base font-bold leading-[1.6] opacity-70">
              Enter your new password and re-enter it for confirmation.
            </p>
            <div className="rounded-[10px] overflow-hidden shadow-[0px_0px_4px_0px_rgba(0,0,0,0.25)]">
              <img
                src={passwordChange05}
                alt="Password Change Step 5"
                className="w-full h-auto"
              />
            </div>
          </div>

          {/* Step 6 */}
          <div className="space-y-4">
            <h3 className="text-lg font-bold opacity-90">
              Step 6: Complete Password Change
            </h3>
            <p className="text-base font-bold leading-[1.6] opacity-70">
              Once you see the password change confirmation message, you can
              log in using your new password.
            </p>
            <div className="rounded-[10px] overflow-hidden shadow-[0px_0px_4px_0px_rgba(0,0,0,0.25)]">
              <img
                src={passwordChange06}
                alt="Password Change Step 6"
                className="w-full h-auto"
              />
            </div>
          </div>
        </div>

        {/* Back to Help */}
        <div className="mt-8">
          <Button
            onClick={() => navigate("/help")}
            className="w-full h-12 flex items-center justify-between"
          >
            <span>Back to Help Center</span>
            <ChevronRight className="w-5 h-5" />
          </Button>
        </div>
      </div>

      <BottomBar />
    </div>
  );
}
